module.exports = __webpack_public_path__ + "static/fonts/Fact-LightItalic.779d128.eot";